export type DocumentoValidacaoNivel = {
  id: string;
  documentoSolicitado: string;
  descricao: string;
  obrigatorio: boolean;
  possuiNumero: boolean;
  possuiEmitidoEm: boolean;
  ordem: number;
};

export type SituacaoDocumento =
  | 'PENDENTE'
  | 'APROVADO'
  | 'REJEITADO'
  | 'SOLICITADO_REENVIO';

export type UsuarioDocumento = {
  id: string;
  documentoValidacaoNivel: DocumentoValidacaoNivel;
  situacao: SituacaoDocumento;
  motivoReenvio?: string;
};

export type Solicitacao = {
  id: string;
  status: SituacaoDocumento;
  motivoRejeicao?: string;
  documentos: UsuarioDocumento[];
};

export type ItemFormulario = {
  key: string;
  nivel: DocumentoValidacaoNivel;
};

export const situacaoLabel: { [situacao: string]: string } = {
  PENDENTE: 'Pendente',
  APROVADO: 'Aprovado',
  REJEITADO: 'Rejeitado',
  SOLICITADO_REENVIO: 'Solicitado reenvio'
};

export const situacaoColor: {
  [situacao: string]: 'warning' | 'positive' | 'negative';
} = {
  PENDENTE: 'warning',
  APROVADO: 'positive',
  REJEITADO: 'negative',
  SOLICITADO_REENVIO: 'warning'
};

export const podeReenviar = (situacao: string) =>
  situacao === 'REJEITADO' || situacao === 'SOLICITADO_REENVIO';

export const hoje = () => {
  const data = new Date();
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const dia = String(data.getDate()).padStart(2, '0');
  return `${data.getFullYear()}-${mes}-${dia}`;
};
